import { FormControl, MenuItem, Pagination, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { imageURL } from 'Config/endpoints';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { getProductsFn, postProductStatusFn, postProductTypeFn } from 'Services/Inventory';

const Products = () => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [totalPage, setTotalPage] = useState(1);
    const types = [
        "Publish",
        "Featured",
        "New Arrivals",
        "Best Sellers",
        "Top Rated",
        "Discounted"
    ]

    const { data: getProductResponse, refetch: refetchProducts } = useQuery({
        queryKey: ["get-products-list", page, search],
        queryFn: () => getProductsFn({ page, search })
    })

    const { mutate: postProductType } = useMutation(postProductTypeFn, {
        onSuccess: (response) => {
            if (response?.status === 200) {
                toast.success(response?.data?.message);
            }
            refetchProducts();
        }
    });

    const handleChange = (event, value) => {
        setPage(value);
    };

    const { mutate: postProductStatus } = useMutation(postProductStatusFn, {
        onSuccess: (response) => {
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                refetchProducts();
            }
        },
        onError: (error) => {
            refetchProducts();
        }
    })

    useEffect(() => {
        if (getProductResponse?.data) {
            setTotalPage(getProductResponse.data.total_pages || 1);
        }
    }, [getProductResponse]);

    const hanleEnableDisable = (id) => {
        const formData = new FormData();
        formData.append("product_id", id);
        postProductStatus(formData);
    }

    return (
        <div className="!bg-slate-100">
            <div className="flex justify-between">
                <div className="p-2">
                    <p className="text-xl !text-black font font-bold">
                        Product List
                    </p>
                </div>
                {/* <div className="p-2 pt-5">
                    <Button variant="outlined" color="primary" onClick={handleToggleAddCustomizationHeader}>
                        <AddIcon />
                        Add Customization Header
                    </Button>
                </div> */}
                {/* <AddCustomiseHeaderForm
                open={toggleAddCustomizationHeader}
                handleClose={handleToggleAddCustomizationHeader}
                ids={ids}
                setIds={setIds}
                header={editHeader}
                refetchHeader={refetchHeader}
            /> */}
            </div>
            <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
                <div className="flex items-center justify-between my-2">
                    <span className="flex gap-3">
                        <input
                            className="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
                            placeholder="Search for anything..."
                            type="text"
                            name="search"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                        />
                    </span>
                </div>
                <TableContainer
                    component={Paper}
                    sx={{ width: "100%", maxHeight: 440 }}
                    className="!text-black !mx-auto !bg-white overflow-auto px-2"
                >
                    <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    ID
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    TITLE
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Price
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Unit Type
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Category
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Production Capacity
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Seller
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Video
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Image
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Code
                                </TableCell>
                                <TableCell
                                    style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Type
                                </TableCell>
                                <TableCell
                                    style={{ fontFamily: "'Poppins', sans-serif" }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    Enable/Disable
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {getProductResponse?.data?.data?.data.map((row, index) => (
                                <TableRow key={row?.id} className="!text-slate-700">
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.id}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.title || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        ₹{row?.price || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.unit_type || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.category_info?.length > 0 ? row?.category_info[0]?.title : "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.production_capacity || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.seller_info?.length > 0 ? row?.seller_info[0]?.company : "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.video || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.image ? (
                                            <img src={imageURL(row?.images[0])} className="h-8 mx-auto w-8" alt="header" />
                                        ) : (
                                            "--"
                                        )}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {row?.code || "--"}
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                                        {/* {row?.type || "--"} */}
                                        <FormControl fullWidth>
                                            <Select
                                                name="header"
                                                size="small"
                                                className="mt-2"
                                                value={row?.type}
                                                onChange={(e) => {
                                                    postProductType({
                                                        product_id: row?.id,
                                                        type: e.target.value
                                                    })
                                                }}
                                            >
                                                {types.map((elem) => (
                                                    <MenuItem value={elem} key={elem}>
                                                        {elem}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell className="!text-center !text-[12px]" style={{ fontFamily: "'Poppins', sans-serif" }}>
                                        <Switch
                                            color="success"
                                            checked={row?.active_status}
                                            onChange={() => hanleEnableDisable(row?.id)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="flex justify-center p-2">
                    <Pagination
                        page={page}
                        size="small"
                        count={totalPage}
                        variant="outlined"
                        color="primary"
                        onChange={handleChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default Products;